// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // load translations from /public/locales
  .use(LanguageDetector) // detect user language (cookie, localStorage, navigator, etc.)
  .use(initReactI18next) // pass i18n to react-i18next
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'hy', 'ru', 'es'],
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: { escapeValue: false }, // React already does XSS protection
    react: { useSuspense: true },
  });

export default i18n;
